<template>
  <div v-if="progress" class="leftbox" style="overflow-y: hidden !important; margin-top: 100px !important;">
    <v-layout align-center justify-center>
      <v-progress-circular :size="100" :width="8" indeterminate color="blue"></v-progress-circular>
    </v-layout>
  </div>
  <div style="overflow-y: hidden !important;" class="leftbox" v-else>
    <v-toolbar style="background-color: white !important;" fixed>
      <v-btn icon @click="toPage('/listchat/')">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <h2>บรอดแคสต์</h2>
    </v-toolbar>
    <v-tabs slot="extension" v-model="tabs" fixed-tabs color="transparent" icons-and-text centered>
      <v-tabs-slider></v-tabs-slider>
      <!-- <v-tab href="#tab-1" :key="1">
        ข้อมูลการบรอดแคสต์
        <v-icon style="font-size: 25px !important;color: #2562af !important;">fas fa-info-circle</v-icon>
      </v-tab> -->
      <v-tab href="#tab-1" :key="2">
        บรอดแคสต์ข้อความ
        <v-icon style="font-size: 25px !important;color: #2562af !important;">chat</v-icon>
      </v-tab>
      <v-tab href="#tab-2" :key="3">
        บรอดแคสต์รูปภาพ, ไฟล์, วิดีโอ
        <v-icon style="font-size: 25px !important;color: #2562af !important;">fas fa-file</v-icon>
      </v-tab>
      <v-tab href="#tab-3" :key="4">
        เวลาบรอดแคสต์
        <v-icon style="font-size: 25px !important;color: #2562af !important;">alarm</v-icon>
      </v-tab>
      <v-tab href="#tab-4" :key="5" v-if="statebroadcast">
        รายการข้อความที่บรอดแคสต์
        <v-icon style="font-size: 25px !important;color: #2562af !important;">mdi-format-list-bulleted</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs" class="white elevation-1">
      <v-tab-item id="tab-1" style="height: calc(100vh - 64px);">
        <v-flex xs12 xl12 md12 sm12 lg12>
          <v-list>
            <v-flex xs12 xl12 md12 sm12 lg12 style="height: calc(100vh - 200px);" class="scrolling-wrapper">
              <template>
                <v-layout column wrap justify-start align-start class="pl-5 mt-3">
                  <!-- <span style="font-size: 18px;">คุณบรอดแคสต์ข้อความไปแล้วทั้งหมด <b>{{count_msg}}/{{max_msg}}</b> ข้อความ</span> -->
                  <span style="font-size: 18px;" v-if="count_msg >= max_msg"><v-icon color="#2874A6" style="font-size: 20px; margin-right: 5px;">fas fa-broadcast-tower</v-icon> คุณบรอดแคสต์ข้อความไปแล้วทั้งหมด <b style="color: red;">{{count_msg}}/{{max_msg}}</b> ข้อความ</span>
                  <span style="font-size: 18px;" v-else><v-icon color="#2874A6" style="font-size: 20px; margin-right: 5px;">fas fa-broadcast-tower</v-icon> คุณบรอดแคสต์ข้อความไปแล้วทั้งหมด <b>{{count_msg}}/{{max_msg}}</b> ข้อความ</span>
                  <span style="font-size: 18px;" v-if="num_friends !== ''"><v-icon color="green" dark style="font-size: 20px; margin-right: 5px;">fas fa-user-friends</v-icon> จำนวนเพื่อนทั้งหมด <b>{{num_friends}}</b> คน</span>
                </v-layout>
                <v-layout justify-center align-center style="margin-top: 15px; padding-right: 25px;padding-left: 25px;">
                  <v-textarea solo name="input-7-4"
                    label="ข้อความที่ต้องการบรอดแคสต์..."
                    v-model="message"
                    style="color: white !important;"
                    ></v-textarea>
                </v-layout>
                <v-layout justify-center align-center row wrap>
                  <v-btn v-on:click="sendbroadcast()" :loading="loading" :disabled="message && loading" class="buttonsubmit">
                    <v-icon dark style="font-size: 16px; margin-right: 5px;">far fa-envelope</v-icon>
                    ส่งข้อความ
                  </v-btn>
                  <!-- <v-btn v-on:click="sendbroadcast()" :loading="loading" :disabled="message && loading" class="buttonsubmit">ส่งข้อความ</v-btn> -->
                  <v-btn v-on:click="clear()" class="buttoncancel">ยกเลิก</v-btn>
                </v-layout>
              </template>
            </v-flex>
          </v-list>
        </v-flex>
      </v-tab-item>

      <v-tab-item id="tab-2" style="height: calc(100vh - 64px);" class="scrolling-wrapper">
        <v-flex xs12 xl12 md12 sm12 lg12>
          <v-list>
            <v-flex xs12 xl12 md12 sm12 lg12 style="height: calc(100vh - 200px);" class="scrolling-wrapper">
              <template>
                <v-layout column wrap justify-start align-start class="pl-5 mt-3">
                  <span style="font-size: 18px;" v-if="count_msg >= max_msg"><v-icon color="#2874A6" style="font-size: 20px; margin-right: 5px;">fas fa-broadcast-tower</v-icon> คุณบรอดแคสต์ข้อความไปแล้วทั้งหมด <b style="color: red;">{{count_msg}}/{{max_msg}}</b> ข้อความ</span>
                  <span style="font-size: 18px;" v-else><v-icon color="#2874A6" style="font-size: 20px; margin-right: 5px;">fas fa-broadcast-tower</v-icon> คุณบรอดแคสต์ข้อความไปแล้วทั้งหมด <b>{{count_msg}}/{{max_msg}}</b> ข้อความ</span>
                  <span style="font-size: 18px;" v-if="num_friends !== ''"><v-icon color="green" dark style="font-size: 20px; margin-right: 5px;">fas fa-user-friends</v-icon> จำนวนเพื่อนทั้งหมด <b>{{num_friends}}</b> คน</span>
                </v-layout>
                <v-flex xs12 style="display: flex; justify-content: center;">
                  <!-- <input type="file" ref="fileTest" style="display: none;" @change="setFileName()"> -->
                  <div class="borderfile" v-if="fileName !==''">
                    <!-- <a class="close-classic" v-if="fileData" @click="reset()"></a> -->
                    <div  v-if="extension(fileName) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center;">
                      <img  id="img_file" v-if="fileData" style="height: 150px !important; width: 150px !important; display: flex; justify-content: center;" />
                        <b class="text2">{{ fileName }}</b>
                    </div>
                    <div v-else style="text-align: center; display: grid; justify-content: center;" >
                      <v-icon style="font-size: 70px !important; color: #1a222c;display: flex;justify-content: center; margin-top: 10px;">{{ extension(fileName)}}</v-icon>
                      <b class="text2">{{ fileName }}</b>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 style="justify-content: center; display: flex;">
                  <form ref="fileform" style="margin-top: 30px; height: 100px;">
                    <img :src="require('../../assets/photo.png')" style="width: 60px;"/>
                    <label>
                      <b class="CSChatThai" style="text-decoration: underline;cursor: pointer;text-indent: 5em;">เลือกไฟล์</b>
                      <input type="file" ref="fileTest"  @change="setFileName()" style="display: none !important;" />
                    </label>
                  </form>
                </v-flex>
                <v-layout justify-center align-center row wrap>
                  <v-btn v-if="fileData == ''" disabled class="buttonsubmit">
                    <v-icon dark style="font-size: 16px; margin-right: 5px;">fas fa-file</v-icon>
                    ส่งไฟล์
                  </v-btn>
                  <!-- <v-btn @click="broadcast()" :loading="loading" :disabled="loading" class="buttonsubmit" v-else>ส่งไฟล์</v-btn> -->
                  <v-btn @click="broadcast()" :loading="loading" :disabled="loading" class="buttonsubmit" v-else>
                    <v-icon dark style="font-size: 16px; margin-right: 5px;">fas fa-file</v-icon>
                    ส่งไฟล์
                  </v-btn>
                  <v-btn @click="reset()" class="buttoncancel">ยกเลิก</v-btn>
                </v-layout>
              </template>
            </v-flex>
          </v-list>
        </v-flex>
      </v-tab-item>

      <v-tab-item id="tab-3" style="height: calc(100vh - 164px);" class="scrolling-wrapper" >
       <v-container>
          <v-layout row wrap style="padding-bottom:20px;">
            <v-flex>
              <h3 style="margin-top:2%; text-align:left">รายการบรอดแคสต์</h3>
            </v-flex>
            <v-flex>
              <div style="text-align:right;">
                <v-btn color="#2562af" class="btnCreate" dark  @click="opendialog()">
                  <v-icon>add</v-icon>
                  &nbsp;
                  สร้างรายการ
                </v-btn >
              </div>
            </v-flex>
          </v-layout>
            <v-data-table
              :headers="headers"
              :items="list_brocast"
              class="elevation-1"
            >
          <!-- <template slot="headerCell" slot-scope="props"> -->
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ props.header.text }}
                </span>
              </template>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip> -->
          <!-- </template> -->
          <template v-slot:items="props">
            <!-- <td>{{ props.item.id }}</td> -->
            <!-- <td class="text-xs-left">{{ props.item._id }}</td> -->
            <td class="text-xs-center">{{ formatDate(props.item.create_date) }}</td>
            <td class="text-xs-center">{{ typeBroadcast(props.item.type) }}</td>
            <td class="text-xs-center">{{ typeMessage(props.item.type_message) }}</td>
            <!-- <td class="text-xs-left">{{ props.item.state }}</td> -->
            <td class="text-xs-center">
              <div v-if="props.item.type_message === 'image'">
              <img :src="props.item.message" height="50" width="50"/>
              </div>
              <div v-if="props.item.type_message === 'message'">
                {{props.item.message}}
              </div>
              <div v-if="props.item.type_message === 'file'">
                <v-icon style="font-size: 70px !important; color: #1a222c;display: flex;justify-content: center; margin-top: 10px;">{{ extension(props.item.message)}}</v-icon>
                 <a target="_blank" :href="props.item.message" class="showfileurl">ดูไฟล์</a>
              </div>
            </td>
            <td class="text-xs-center">
              <v-btn icon small @click="delete_set_broadcast(props.item)">
                <v-icon color="red">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
<!--
            <v-data-table
              :headers="headersBroadcast"
              :items="BrodcastItem"
              class="elevation-1"
              :pagination.sync="pagination"
            >
              <template v-slot:items="props" >
                <td class="text-xs-left">
                  <div class="showfile" v-if="extension(props.item.filenames) == 'fas fa-file-image'">
                    <v-img  :src="props.item.files"  aspect-ratio="1.56" contain style="margin-top:1px;" />
                  </div>
                  <div class="showfile" v-if="extension(props.item.filenames) != 'fas fa-file-image' && props.item.files !== ''">
                    <v-layout align-center justify-center row fill-height>
                      <v-flex style="text-align:center;">
                        <v-icon style="font-size: 50px !important; margin-top:10px;">{{extension(props.item.filenames)}}</v-icon>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  <h5 style="width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color:#6c6c6c;">{{props.item.filenames}}</h5>
                                </div>
                              </template>
                              <span>{{props.item.filenames}}</span>
                            </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </div>
                </td>
                <td class="text-xs-left">
                  <div>
                    {{ props.item.text }}
                  </div>
                </td>
                <td class="text-xs-left">{{ props.item.createBy }}</td>
                <td class="text-xs-left">{{ formatDate(props.item.createDate) }}</td>
                <td class="text-xs-left">
                  <div>
                  <v-flex v-if="props.item.type === 'Days' ">
                    <v-flex v-if="props.item.dates.length === 7" >
                      <span>{{allDay}}</span>
                    </v-flex>
                    <v-flex v-if="props.item.dates.length < 7"  >
                      <span v-for="(item,index) in props.item.dates" :key="index" >
                        {{item}}
                      </span>
                    </v-flex>
                  </v-flex>
                    <v-flex v-if="props.item.type === 'DayOnly' && props.item.dates.length != 0">
                      <span v-for="item in props.item.dates" :key="item">
                        {{formatDate(new Date(item))}}
                      </span>
                    </v-flex>
                  </div>
                  <div>
                    {{ props.item.time }}
                  </div>

                </td>
                <td class="text-xs-center">
                  <v-layout align-center justify-center row fill-height>
                      <v-btn fab outline small color="#A9A9A9" @click="opendialogEdit()">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn  fab outline small color="#C31212">
                        <i class="fa fa-trash"></i>
                      </v-btn>
                  </v-layout>
                </td>
              </template>
            </v-data-table> -->
          </v-container>
      </v-tab-item>
      <v-tab-item id="tab-4" style="height: calc(100vh - 134px);" class="scrolling-wrapper">
        <ListBroadcastMessage :tokenbot="tokenbot"></ListBroadcastMessage>
      </v-tab-item>
    </v-tabs-items>
    <DialogTime :dialogBroadcastTime="dialogBroadcastTime" @closedialogTime="closedialogTime"/>
  </div>
</template>
<script>
import { Decode } from '@/services'
import DialogTime from '../../components/LayoutOnMobile/dialog/BroadcastTime'
import ListBroadcastMessage from '../../components/LayoutOnMobile/dialog/ListBroadcastMessage'
var _ = require('lodash')
export default {
  components: {
    DialogTime,
    ListBroadcastMessage
  },
  data: () => ({
    tokenbot: '',
    fileName: '',
    isLoading: false,
    fileData: '',
    loading: false,
    message: '',
    tabs: 'tab-1',
    tokenservice: '',
    listfriend: [],
    progress: false,
    search: '',
    count_msg: '',
    max_msg: '',
    num_friends: '',
    list_brocast: [],
    headers: [
      // { text: 'id', sortable: false, value: '_id' },
      { text: 'วันที่สร้าง', sortable: false, value: 'create_date', align: 'center' },
      { text: 'ประเภท', sortable: false, value: 'type', align: 'center' },
      { text: 'ประเภทข้อความ', sortable: false, value: 'type_message', align: 'center' },
      // { text: 'state', sortable: false, value: 'state' },
      // { text: 'valid', sortable: false, value: 'valid' },
      { text: 'ข้อความ', sortable: false, value: 'message', align: 'center' },
      { text: '', sortable: false, value: 'message', align: 'center' }
      // message
    ],
    bot_name: '',
    access_token: 'Bearer A00faf32b63b858c280058e96888a450b53458eedbbac4710951949336c0561a53ad3c7684f20428f91def8c796dc10bf',
    dialogBroadcastTime: false,
    check: true,
    statebroadcast: false
  }),
  computed: {
  },
  watch: {
    '$route.params.id' () {
      // this.getlistfrienbot()
      this.tokenbot = this.$route.params.id
    },
    check () {
      // console.log(this.check)
      if (this.check !== true) {
        this.getListBroadcast()
      }
    }
  },
  mounted () {
    this.getListBroadcast()
    this.formatDate()
  },
  created () {
    this.num_friends = localStorage.getItem('num_friends')
    this.tokenbot = this.$route.params.id
    // console.log(parseInt(this.num_friends) + this.count_msg)
    this.tokenservice = 'Bearer ' + Decode.decodeToken(localStorage.getItem('tokenservice'))
    // this.getlistfrienbot()
    this.get_count_broadcast()
    this.get_infor_bot()
    this.get_list_broadcast()
  },
  methods: {
    get_list_broadcast () {
      this.axios.post(process.env.VUE_APP_API_OFFICIAL + `/get-list-broadcast`, {
        bot_id: this.tokenbot,
        time: ''
      }).then((response) => {
        if (response.data.status === 'success') {
          this.statebroadcast = true
        } else {
          this.statebroadcast = false
        }
      }).catch(error => {
        console.log(error)
        this.statebroadcast = false
      })
    },
    delete_set_broadcast (item) {
      // console.log(item)
      this.$swal({
        title: '<strong style="width: 410px;">คุณต้องการลบการส่งบรอดแคสต์นี้ใช่หรือไม่?</strong>',
        // text: 'คุณต้องการส่งข้อความไปหาเพื่อนทุกคนใช่หรือไม่',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          var body = {
            bot_id: this.$route.params.id,
            _id: item._id
          }
          this.axios.post(process.env.VUE_APP_API_BROADCAST + '/api/v1/disable-interval', body, {
            headers: {
              Authorization: this.access_token
            }
          }).then((response) => {
            // console.log(response.data)
            if (response.data.status === 'success') {
              var index = _.findIndex(this.list_brocast, function (o) { return o._id === item._id })
              this.list_brocast.splice(index, 1)
              this.$swal('', 'ลบรายการส่งบรอดแคสต์สำเร็จ', 'success')
            }
          }).catch(error => {
            this.$swal('', 'ไม่สามารถลบรายการบรอดแคสต์ กรุณาลองใหม่ภายหลัง', 'success')
            console.log(error)
          })
        }
      })
    },
    get_infor_bot () {
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/getbotbytoken', { bot_id: this.$route.params.id, tokenuser: Decode.decodeToken(localStorage.getItem('tokenuser')) }).then((response) => {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          this.bot_name = response.data.data_bot[0].nickname
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    get_count_broadcast () {
      var day = new Date()
      var month = day.getMonth() + 1
      var year = day.getFullYear()
      // console.log(month.toString())
      // console.log(year.toString())
      this.axios.post(process.env.VUE_APP_API_IMAGE + '/get_count_broadcast', { bot_id: this.$route.params.id, month: month.toString(), year: year.toString() }).then((response) => {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          // this.list_brocast = response.data.data
          // console.log(this.list_brocast)
          this.count_msg = response.data.data.count_msg
          this.max_msg = response.data.data.max_msg
          // this.max_msg = 47
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    reset () {
      this.fileName = ''
      this.fileData = ''
      this.loading = false
    },
    setFileName () {
      this.fileName = this.$refs.fileTest.files[0].name
      var typeFile = this.$refs.fileTest.files[0].type
      this.fileData = this.$refs.fileTest.files[0]
      // console.log(this.$refs.fileTest.files[0].size / 1024 / 1024)
      if (this.$refs.fileTest.files[0].size / 1024 / 1024 > 25) {
        this.$swal({ title: 'ไฟล์ของท่านมีขนาดเกิน 25 MB', type: 'warning' })
        this.reset()
      }
      if (typeFile.search('image') !== -1) {
        var fr = new FileReader()
        fr.onload = function () {
          document.getElementById('img_file').src = fr.result
        }
        fr.readAsDataURL(this.fileData)
      }
    },
    extension (files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var file = ['ai', 'ps', 'psd']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
      var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4', 'divx', 'dat']
      var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (file.includes(extension)) {
        return 'fas fa-file'
      } else if (media.includes(extension)) {
        return 'fas fa-file-video'
      } else if (audio.includes(extension)) {
        return 'fas fa-file-audio'
      } else {
        return 'fas fa-file-alt'
      }
    // return extension[extension.length-1]
    },
    sendbroadcast () {
      this.$swal({
        title: '<strong style="width: 410px;">ยืนยันการส่งข้อความจากบัญชี <br><b style="font-weight: 800; margin-left: 10px; color: #3185d6; margin-top: 10px; font-size: 30px;">' + this.bot_name + '</b></strong>',
        // title: 'ยืนยันการส่งข้อความจากบัญชี<b style="font-weight: 800; margin-left: 10px; color: #3185d6;">' + this.bot_name + '</b>',
        text: 'คุณต้องการส่งข้อความไปหาเพื่อนทุกคนใช่หรือไม่',
        // html: 'คุณต้องการใช้บัญชี <b style="font-weight: 600; color: #3185d6;">' + this.bot_name + '</b> ส่งข้อความไปหาเพื่อนทุกคนใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.loading = true
          // ถ้าข้อความมี spacebar แทยค่าด้วย \u00a0
          var data = this.message
          for (var l = 0; l < data.length; l++) {
            data = data.replace(/ /g, '\u00a0')
          }
          this.axios.post(process.env.VUE_APP_API_BRD + '/bot/broadcast_msg', { tokenuser: this.$route.params.id, message: data }).then((response) => {
            // console.log(response.data.status)
            // console.log(response.status)
            // this.loading = false
            if (response.data.status === 'success') {
              // console.log(response.data)
              // console.log(JSON.parse(localStorage.getItem('listchat')))
              var listchat = JSON.parse(localStorage.getItem('listchat'))
              // filter list chat type user && state === active
              var filterlistchat = _.filter(listchat, function (o) { return o.type === 'user' && o.state === 'active' })
              var indexlistchat = []
              // หา index ใน listchat ที่เก็บใน localStorage เพื่อ set new message ใน listchat ตอน broadcast
              for (var i = 0; i < filterlistchat.length; i++) {
                indexlistchat[i] = _.findIndex(listchat, function (o) { return o.tokenroom === filterlistchat[i].tokenroom })
                // console.log(indexlistchat[i])
                listchat[indexlistchat[i]].message = response.data.data.message
                listchat[indexlistchat[i]].timestamp = response.data.data.timestamp
                listchat[indexlistchat[i]].typeofmessage = response.data.data.type
                // listchat[indexlistchat[i]].count_read = parseInt(listchat[indexlistchat[i]].count_read) + 1
              }
              // console.log(indexlistchat)
              // sort listchat ตาม timestame
              listchat = _.sortBy(listchat, ['timestamp']).reverse()
              // console.log(listchat)
              // set listchat ใหม่ใน localStorage
              localStorage.setItem('listchat', JSON.stringify(listchat))
              localStorage.setItem('listchat_length', listchat.length)
              this.$swal({
                title: 'ส่งข้อความสำเร็จ',
                type: 'success',
                showConfirmButton: true,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ตกลง'
              })
              this.loading = false
              this.message = ''
              this.get_count_broadcast()
            } else {
              this.progress = true
            }
          })
        } else {
          this.loading = false
        }
      })
      // if ((this.count_msg <= this.max_msg) && ((parseInt(this.num_friends)) <= (this.max_msg - this.count_msg))) {
      //   this.$swal({
      //     title: 'ยืนยันการส่งข้อความ',
      //     text: 'คุณต้องการส่งข้อความไปหาเพื่อนทุกคนใช่หรือไม่',
      //     type: 'warning',
      //     showCancelButton: true,
      //     confirmButtonColor: '#3085d6',
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'ตกลง',
      //     cancelButtonText: 'ยกเลิก'
      //   }).then((result) => {
      //     if (result.value) {
      //       this.axios.post(process.env.VUE_APP_API_IMAGE + '/broadcast_message', { tokenuser: this.$route.params.id, message: this.message }).then((response) => {
      //         if (response.data.status === 'success') {
      //           this.$swal({
      //             title: 'ส่งข้อความสำเร็จ',
      //             type: 'success',
      //             showConfirmButton: true,
      //             confirmButtonColor: '#3085d6',
      //             confirmButtonText: 'ตกลง'
      //           })
      //           this.loading = false
      //           this.message = ''
      //           this.get_count_broadcast()
      //         } else {
      //           this.progress = true
      //         }
      //       })
      //     } else {
      //       this.loading = false
      //     }
      //   })
      // } else if (((parseInt(this.num_friends) + this.count_msg) >= this.max_msg) && (this.count_msg < this.max_msg)) {
      //   var nummsg = this.max_msg - this.count_msg
      //   var maxmsg = parseInt(this.num_friends) - nummsg
      //   this.$swal({
      //     title: 'ยืนยันการส่งข้อความ',
      //     html: 'คุณสามารถบรอดแคสต์ข้อความได้อีก <b style="font-weight: 600;">' + nummsg + ' ข้อความ</b> ส่วนจำนวนข้อความที่เกินมา <b style="font-weight: 600;">' + maxmsg + ' ข้อความ</b> จะถูกเรียกเก็บค่าใช้จ่ายภายหลัง คุณต้องการบรอดแคสต์ข้อความใช่หรือไม่?',
      //     type: 'warning',
      //     showCancelButton: true,
      //     confirmButtonColor: '#3085d6',
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'ตกลง',
      //     cancelButtonText: 'ยกเลิก'
      //   }).then((result) => {
      //     if (result.value) {
      //       this.axios.post(process.env.VUE_APP_API_IMAGE + '/broadcast_message', { tokenuser: this.$route.params.id, message: this.message }).then((response) => {
      //         if (response.data.status === 'success') {
      //           this.$swal({
      //             title: 'ส่งข้อความสำเร็จ',
      //             type: 'success',
      //             showConfirmButton: true,
      //             confirmButtonColor: '#3085d6',
      //             confirmButtonText: 'ตกลง'
      //           })
      //           this.loading = false
      //           this.message = ''
      //           this.get_count_broadcast()
      //         } else {
      //           this.progress = true
      //         }
      //       })
      //     } else {
      //       this.loading = false
      //     }
      //   })
      // } else if (this.count_msg >= this.max_msg) {
      //   this.$swal({
      //     title: 'ยืนยันการส่งข้อความ',
      //     html: 'คุณบรอดแคสต์ข้อความเกินจำนวนที่กำหนด ข้อความที่เกินมาจะถูกเรียกเก็บค่าใช้จ่ายภายหลัง คุณต้องการบรอดแคสต์ข้อความใช่หรือไม่?',
      //     type: 'warning',
      //     showCancelButton: true,
      //     confirmButtonColor: '#3085d6',
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'ตกลง',
      //     cancelButtonText: 'ยกเลิก'
      //   }).then((result) => {
      //     if (result.value) {
      //       this.axios.post(process.env.VUE_APP_API_IMAGE + '/broadcast_message', { tokenuser: this.$route.params.id, message: this.message }).then((response) => {
      //         if (response.data.status === 'success') {
      //           this.$swal({
      //             title: 'ส่งข้อความสำเร็จ',
      //             type: 'success',
      //             showConfirmButton: true,
      //             confirmButtonColor: '#3085d6',
      //             confirmButtonText: 'ตกลง'
      //           })
      //           this.loading = false
      //           this.message = ''
      //           this.get_count_broadcast()
      //         } else {
      //           this.progress = true
      //         }
      //       })
      //     } else {
      //       this.loading = false
      //     }
      //   })
      // } else {
      //   this.$swal({
      //     html: 'ไม่สามารถส่งข้อความได้ เนื่องจากคุณส่งข้อความไปแล้ว <b style="font-weight: 600;">' + this.count_msg + ' ข้อความ</b> ซึ่งเกินแพคเก็จที่กำหนด',
      //     type: 'warning',
      //     showConfirmButton: true,
      //     confirmButtonColor: '#3085d6',
      //     confirmButtonText: 'ตกลง'
      //   })
      //   this.loading = false
      //   this.message = ''
      // }
    },
    broadcast () {
      if (!this.fileData) {
        this.$swal({ title: 'กรุณาเลือกไฟล์', type: 'warning' })
        return
      }
      console.log(this.extension(this.fileData.name))
      var typemessage = ''
      var api = ''
      if (this.extension(this.fileData.name) === 'fas fa-file-image') {
        typemessage = 'image'
        api = process.env.VUE_APP_API_BRD + '/bot/broadcast_file'
      } else if (this.extension(this.fileData.name) === 'fas fa-file-video') {
        typemessage = 'video'
        api = process.env.VUE_APP_API_BRD_VIDEO
      } else {
        typemessage = 'file'
        api = process.env.VUE_APP_API_BRD + '/bot/broadcast_file'
      }
      console.log(typemessage)
      this.$swal({
        // title: 'ยืนยันการส่งข้อความ',
        title: '<strong style="width: 410px;">ยืนยันการส่งข้อความจากบัญชี <br><b style="font-weight: 800; margin-left: 10px; color: #3185d6; margin-top: 10px; font-size: 30px;">' + this.bot_name + '</b></strong>',
        // title: 'ยืนยันการส่งข้อความจากบัญชี <b style="font-weight: 800; margin-left: 10px; color: #3185d6;">' + this.bot_name + '</b>',
        text: 'คุณต้องการส่งข้อความไปหาเพื่อนทุกคนใช่หรือไม่',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.loading = true
          var data = new FormData()
          data.append('tokenuser', this.$route.params.id)
          data.append('file', this.$refs.fileTest.files[0])

          this.axios.post(api, data).then((response) => {
            this.loading = false
            if (response.data.status === 'success') {
              this.reset()
              // console.log(response.data)
              var listchat = JSON.parse(localStorage.getItem('listchat'))
              // filter list chat type user && state === active
              var filterlistchat = _.filter(listchat, function (o) { return o.type === 'user' && o.state === 'active' })
              var indexlistchat = []
              // หา index ใน listchat ที่เก็บใน localStorage เพื่อ set new message ใน listchat ตอน broadcast
              for (var i = 0; i < filterlistchat.length; i++) {
                indexlistchat[i] = _.findIndex(listchat, function (o) { return o.tokenroom === filterlistchat[i].tokenroom })
                listchat[indexlistchat[i]].message = response.data.data.message
                listchat[indexlistchat[i]].timestamp = response.data.data.timestamp
                listchat[indexlistchat[i]].typeofmessage = typemessage
                // listchat[indexlistchat[i]].count_read = parseInt(listchat[indexlistchat[i]].count_read) + 1
              }
              // sort listchat ตาม timestame
              listchat = _.sortBy(listchat, ['timestamp']).reverse()
              // console.log(listchat)
              // set listchat ใหม่ใน localStorage
              localStorage.setItem('listchat', JSON.stringify(listchat))
              localStorage.setItem('listchat_length', listchat.length)
              this.$swal({ title: 'ส่งข้อความสำเร็จ', type: 'success' })
              this.get_count_broadcast()
            }
          })
        }
      })
      // if ((this.count_msg <= this.max_msg) && ((parseInt(this.num_friends)) <= (this.max_msg - this.count_msg))) {
      //   this.$swal({
      //     title: 'ยืนยันการส่งข้อความ',
      //     text: 'คุณต้องการส่งข้อความไปหาเพื่อนทุกคนใช่หรือไม่',
      //     type: 'warning',
      //     showCancelButton: true,
      //     confirmButtonColor: '#3085d6',
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'ตกลง',
      //     cancelButtonText: 'ยกเลิก'
      //   }).then((result) => {
      //     if (result.value) {
      //       this.loading = true
      //       var data = new FormData()
      //       data.append('tokenuser', this.$route.params.id)
      //       data.append('file', this.$refs.fileTest.files[0])
      //
      //       this.axios.post(process.env.VUE_APP_API_IMAGE + '/broadcast_file', data).then((response) => {
      //         this.loading = false
      //         if (response.data.status === 'success') {
      //           this.reset()
      //           this.$swal({ title: 'ส่งข้อความสำเร็จ', type: 'success' })
      //           this.get_count_broadcast()
      //         }
      //       })
      //     }
      //   })
      // } else if (((parseInt(this.num_friends) + this.count_msg) >= this.max_msg) && (this.count_msg < this.max_msg)) {
      //   var nummsg = this.max_msg - this.count_msg
      //   var maxmsg = parseInt(this.num_friends) - nummsg
      //   this.$swal({
      //     title: 'ยืนยันการส่งข้อความ',
      //     html: 'คุณสามารถบรอดแคสต์ข้อความได้อีก <b style="font-weight: 600;">' + nummsg + ' ข้อความ</b> ส่วนจำนวนข้อความที่เกินมา <b style="font-weight: 600;">' + maxmsg + ' ข้อความ</b> จะถูกเรียกเก็บค่าใช้จ่ายภายหลัง คุณต้องการบรอดแคสต์ข้อความใช่หรือไม่?',
      //     type: 'warning',
      //     showCancelButton: true,
      //     confirmButtonColor: '#3085d6',
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'ตกลง',
      //     cancelButtonText: 'ยกเลิก'
      //   }).then((result) => {
      //     if (result.value) {
      //       this.loading = true
      //       var data = new FormData()
      //       data.append('tokenuser', this.$route.params.id)
      //       data.append('file', this.$refs.fileTest.files[0])
      //       this.axios.post(process.env.VUE_APP_API_IMAGE + '/broadcast_file', data).then((response) => {
      //         this.loading = false
      //         if (response.data.status === 'success') {
      //           this.reset()
      //           this.$swal({ title: 'ส่งข้อความสำเร็จ', type: 'success' })
      //           this.get_count_broadcast()
      //         }
      //       })
      //     } else {
      //       this.loading = false
      //       this.reset()
      //     }
      //   })
      // }
      // else if (this.count_msg >= this.max_msg) {
      //   this.$swal({
      //     html: 'ไม่สามารถบรอดแคสต์ข้อความได้ เนื่องจากคุณบรอสแคสข้อความไปแล้ว <b style="font-weight: 600;">' + this.count_msg + ' ข้อความ</b> ซึ่งเกินจำนวนที่กำหนดไว้ กรุณาติดต่อเจ้าหน้าที่ในการสมัครแพ็กเกจเพิ่มเติม',
      //     type: 'warning',
      //     showConfirmButton: true,
      //     confirmButtonColor: '#3085d6',
      //     confirmButtonText: 'ตกลง'
      //   })
      //   this.loading = false
      //   this.reset()
      // } else {
      //   this.$swal({
      //     html: 'ไม่สามารถส่งข้อความได้ เนื่องจากคุณส่งข้อความไปแล้ว <b style="font-weight: 600;">' + this.count_msg + ' ข้อความ</b> ซึ่งเกินแพคเก็จที่กำหนด',
      //     type: 'warning',
      //     showConfirmButton: true,
      //     confirmButtonColor: '#3085d6',
      //     confirmButtonText: 'ตกลง'
      //   })
      //   this.loading = false
      //   this.reset()
      // }
    },
    clear () {
      this.message = ''
      this.loading = false
    },
    getlistfrienbot () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/web/getlistfriend', { tokenuser: this.$route.params.id }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          this.listfriend = response.data.listfriend
          this.progress = false
        } else {
          this.progress = true
        }
      })
    },
    toPage (data) {
      // console.log(data)
      this.$router.push(data + this.$route.params.id)
    },
    opendialog () {
      this.dialogBroadcastTime = true
    },
    closedialogTime (value) {
      this.check = value
      this.dialogBroadcastTime = value
    },
    getListBroadcast () {
      this.check = true
      var body = {
        bot_id: localStorage.tokenbot
      }
      this.axios.post(process.env.VUE_APP_API_BROADCAST + '/api/get/GetListInterval', body, {
        headers: {
          Authorization: this.access_token
        }
      }).then((response) => {
        if (response.data.status === 'success') {
          // this.list_brocast = response.data.data
          this.list_brocast = _.filter(response.data.data, function (o) { return o.valid === true })
          this.check = true
          // console.log(this.list_brocast)
        }
      })
    },
    formatDate (isoDate) {
      var dateFormat = new Date(isoDate)
      var dd = String(dateFormat.getDate()).padStart(2, '0')
      var mm = String(dateFormat.getMonth() + 1).padStart(2, '0') // january is 0
      var yyyy = dateFormat.getFullYear()
      dateFormat = dd + '/' + mm + '/' + yyyy
      // console.log(dateFormat)
      return dateFormat
    },
    typeBroadcast (type) {
      if (type === 'ondate') {
        return 'วัน'
      } else if (type === 'month') {
        return 'ทุกเดือน'
      } else if (type === 'week') {
        return 'ทุกสัปดาห์'
      } else {
        return 'ทุกวัน'
      }
    },
    typeMessage (message) {
      if (message === 'image') {
        return 'รูปภาพ'
      } else if (message === 'file') {
        return 'ไฟล์'
      } else {
        return 'ข้อความ'
      }
    }
  }
}
</script>
<style type="text/css" scoped>
>>>.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    /* padding-right: 12px; */
    /*font-size: 14px;*/
    font-size: 14px;
    resize: none;
    height: 75px !important;
}
.text2 {
  white-space: nowrap;
  width: 155px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 300px !important;
  height: 185px !important;
  position: relative;
  background: white;
}
.containers {
  width: 576px; margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}

[class*='close-'] {
  color: #777;
  font: 27px/100% arial, sans-serif;
  position: absolute;
  right: 15px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.close-classic:after {
  content: '×'; /* ANSI X letter */
}
.buttonsubmit {
  background-color: #f3982f !important;
  border-radius: 20px !important;
  color: white !important;
  text-transform: none !important;
  border: 1px solid #8080807d;
  border-width: thin;
}
.buttoncancel {
  border-radius: 20px !important;
  color: #4c4c4c !important;
  text-transform: none !important;
  border-color: #8080807d !important;
  border: 1px solid #000000;
  border-width: thin !important;
}
.fontchat {
  color: gray;
  font-size: 12px;
}
.leftbox {
  margin-top: 65px;
  height: calc(100vh - 64px);
  background-color: #fff !important;
  overflow: hidden;
}
>>>.v-input__slot {
  width: 100%;
  border-radius: 20px;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  height: 100px !important;
  border-radius: 20px !important;
  width: 100% !important;
  border-style: solid !important;
  border-color: #c1c1c1 !important;
  box-shadow: none !important;
  border-width: thin !important;
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 2px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
>>>.v-text-field > .v-input__control > .v-input__slot {
    border: transparent !important;
}
>>>.theme--light.v-table thead tr:first-child {
    border-bottom: 1px solid rgba(0,0,0,0.12);
    background-color: #2562af;
}
>>>.theme--light.v-table thead th {
    color: white;
    font-size: 16px !important;
}

</style>
